<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="phone_iphone"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('app_versions') }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @keydown.enter="getDataFromApi"
          @blur="getDataFromApi"
        />
      </v-row>

      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.mandatory="{item}">
          <v-icon
            v-if="item.mandatory"
            color="green"
          >
            check
          </v-icon>
          <v-icon
            v-else
            color="red"
          >
            not_interested
          </v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              medium
              color="red"
              class="mr-5"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-btn
            color="green"
            class="ml-auto mt-5"
            @click="editItem({id: null})"
          >
            <v-icon class="mr-3">
              mdi-plus
            </v-icon>
            {{ $t('new') }}
          </v-btn>
        </v-row>
      </v-col>
    </base-material-card>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('version') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.app_name"
                  :label="`${this.$t('app')} ${this.$t('name')}`"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.version_number"
                  :label="$t('version')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-menu
                  ref="date-menu"
                  v-model="datePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  max-width="290px"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      outlined
                      :value="editedItem.inform_user_date_time"
                      :label="$t('inform_user_date_time')"
                      v-on="on"
                    />
                  </template>

                  <v-date-picker
                    v-model="editedItem.inform_user_date_time"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-checkbox
                  v-model="editedItem.mandatory"
                  :label="$t('mandatory')"
                />
              </v-col>
              <v-col cols="12">
                <base-file-input
                  :item="editedItem.file"
                  :label="$t('file')"
                  outlined
                  dense
                  url="/app/versions/file"
                  @update="updateFile"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'

  export default {
    mixins: [List],
    data () {
      return {
        endpoint: 'app/versions',
        datePicker: false,
        name: 'app_version',
        headers: [
          {
            sortable: false,
            text: this.$t('mandatory'),
            value: 'mandatory',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$t('version'),
            value: 'version_number',
            width: '100%',
          },
          {
            sortable: false,
            text: `${this.$t('app')} ${this.$t('name')}`,
            value: 'app_name',
            width: '100%',
          },
          {
            text: this.$t('inform_user_date_time'),
            value: 'inform_user_date_time',
            align: 'center',
          },
          {
            text: this.$t('created'),
            value: 'created_at',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$t('filename'),
            value: 'file',
            width: '100%',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
        editedItem: {
          version_number: '',
          mandatory: false,
          inform_user_date_time: new Date().toISOString().substr(0, 10),
          file: null,
        },
        defaultItem: {
          version_number: '',
          mandatory: false,
          inform_user_date_time: new Date().toISOString().substr(0, 10),
          file: null,
        },
      }
    },

    methods: {
      onDateTimeSelect: function (val) {
        this.editedItem.inform_user_date_time = this.$moment(val || new Date()).format('YYYY-MM-DD HH:mm:ss')
      },
      updateFile: function (val) {
        this.editedItem.file = val
      },

    },
  }
</script>
